<template>
	<AppFilter @apply="onFilter" v-model="filters" :isPadding="true" @retainValues = "retainFilter" ref="appFilter"/>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		name:"AutomationFilters",
		props: ['dropDownLists'],
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {

		},
		computed: {
            automationFilter:{
                set(val){
					this.$store.commit('updateAutomationFilter',val)
				},
				get(){
					return this.$store.state.automationFilter
				}
            },
            target(){
                // this.reInitialiseFilters()
                return this.$store.state.automation.target
            }
		},
		async mounted() {
            const vm = this
            if(Object.keys(vm.$store.state.accounts.advanceFilter).length && vm.automationFilter.length){
                vm.filters = JSON.parse(JSON.stringify(vm.automationFilter))
                vm.$refs["appFilter"].setFilterActive();
            }
            else{
                vm.setFilters();
            }
		},
		methods: {
            reInitialiseFilters(){
                this.setFilters()
            },
			retainFilter(data){
				if(Object.keys(this.$store.state.accounts.advanceFilter).length){
					this.filters = JSON.parse(JSON.stringify(this.automationFilter)) || []
				}
				else{
					this.filters = JSON.parse(JSON.stringify(data))
				}

			},
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
                    {
							filters[input[i].name] = input[i].value;

					}
                }
				filters.advanceSearchType = "automation";
				let payload = {};
				if(filters["vendor"]){
					if(filters["vendor"].name == 'All'){
						payload.vendor = ''
					}
					else{
						payload.vendor = filters["vendor"].go_vendor_cd
					}
				}
				if(filters["brand"]){
					if(filters["brand"].name == 'All'){
						payload.brand = '';
					}
					else{
						payload.brand = filters["brand"].id
					}
				}
				if(filters["keyword"]){
					if(filters["keyword"].name == 'All'){
						payload.keyword = '';
					}
					else{
						payload.keyword = filters["keyword"].name
				   }
				}
				if(filters["campaign"]){
					if(filters["campaign"].name == 'All'){
						payload.campaign = '';
					}
					else{
						payload.campaign = filters["campaign"].ams_campaign_id
				   }
                }
                if(filters["campaign_group"]){
					if(filters["campaign_group"].name == 'All'){
						payload.campaign_group = '';
					}
					else{
						payload.campaign_group = filters["campaign_group"].id
				   }
                }
                if(filters["product"]){
					if(filters["product"].name == 'All'){
						payload.product = '';
					}
					else{
						payload.product = filters["product"].asin
				   }
				}
				this.$store.state.currentPageNumber = 1;
                this.$store.commit("automation/setadvanceFilterAutomation", payload);
                this.$store.dispatch("automation/getAutomationsFiltered");
			},
			setFilters() {
                this.filters = [];
				this.filters = [
                    {
						name: "break",
						type: "break"
					},
					{
						name: "vendor",
						label: "Vendor",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.vendorList || this.list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "brand",
						label: "Brand",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.brandList || this.list,
						padding:true
					},
					{
						name: "break",
						type: "break"
                    },
                    {
						name: "campaign_group",
						label: "Campaign group",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.campaignGroupList || this.list,
						padding:true
                    },
                    {
						name: "break",
						type: "break"
                    },

					{
						name: "campaign",
						label: "Campaign",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.campaignList || this.list,
						padding:true
                    },
                    {
						name: "break",
						type: "break"
                    },
                    {
						name: "keyword",
						label: "Keyword",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.keywordList || this.list,
						padding:true
					},

                    {
						name: "break",
						type: "break"
					},
                    {
						name: "product",
						label: "Product",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.dropDownLists.productList || this.list,
                        padding:true,
                        listLabel:'product_title',
                        track:'product_title'
                    },
                    {
						name: "break",
						type: "break"
                    }
                ];
                if(this.target==="Campaign"){
                    this.filters=this.filters.slice(0,9)
                }
                else if(this.target==="Brand Profile"){
                        this.filters=this.filters.slice(0,3)
                }
                else if(this.target==="Campaign Group"){
                    this.filters=this.filters.slice(0,7)
                }
                else if(this.target==="Product"){
                    this.filters=this.filters.slice(10,13)
                }
				this.automationFilter = JSON.parse(JSON.stringify(this.filters))
			}

		},
		data() {
			return {
				filters: [],
				list : [],
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
